export const Account = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M8.00016 1.33325C4.32016 1.33325 1.3335 4.31992 1.3335 7.99992C1.3335 11.6799 4.32016 14.6666 8.00016 14.6666C11.6802 14.6666 14.6668 11.6799 14.6668 7.99992C14.6668 4.31992 11.6802 1.33325 8.00016 1.33325ZM8.00016 3.99992C9.28683 3.99992 10.3335 5.04659 10.3335 6.33325C10.3335 7.61992 9.28683 8.66658 8.00016 8.66658C6.7135 8.66658 5.66683 7.61992 5.66683 6.33325C5.66683 5.04659 6.7135 3.99992 8.00016 3.99992ZM8.00016 13.3333C6.64683 13.3333 5.04683 12.7866 3.90683 11.4133C5.07457 10.4971 6.51591 9.99912 8.00016 9.99912C9.48442 9.99912 10.9258 10.4971 12.0935 11.4133C10.9535 12.7866 9.3535 13.3333 8.00016 13.3333Z"
        fill="#760000"
      />
    </svg>
  );
};
